<div *ngIf="calculationResponse">
  <table *ngIf="calculationTableConfig.responseSuccessful" class="price-table">
    <thead>
      <tr>
        <th></th>
        <th>
          Quantity 1:
          {{ calculatorService.convertToLocaleUsString(quantities[0]) }}
        </th>
        <th *ngIf="calculationTableConfig.showSecondCol">
          Quantity 2:
          {{
            calculatorService.convertToLocaleUsString(quantities[1]) ||
              calculatorService.convertToLocaleUsString(quantities[2])
          }}
        </th>
        <th *ngIf="calculationTableConfig.showThirdCol">
          Quantity 3:
          {{ calculatorService.convertToLocaleUsString(quantities[2]) }}
        </th>
      </tr>
    </thead>
    <tbody>
      <app-ancillary-item-group
        style="display: contents"
        *ngFor="let groupName of responseAncillaryGroupTypes; index as i"
        [calculationTableConfig]="calculationTableConfig"
        [calcReponse]="calculationResponse.data"
        [headLineText]="groupName.name"
        [invoiceItemsAncillaryType]="groupName.value"
        [quantities]="quantities"
      ></app-ancillary-item-group>
    </tbody>
    <tfoot>
      <tr class="total">
        <td class="headline">{{ "Total" }}</td>
        <td>
          {{ calculatorService.convertToLocaleUsPriceString(totals[0], 2) }}
          <span class="per-each" *ngIf="quantities[0] > 0">
            ({{ calculatorService.convertToLocaleUsPriceString(totals[0] / quantities[0], 2) }}/each)
          </span>
        </td>
        <td *ngIf="calculationTableConfig.showSecondCol">
          {{ calculatorService.convertToLocaleUsPriceString(totals[1], 2) }}
          <span class="per-each" *ngIf="quantities[1] > 0">
            ({{ calculatorService.convertToLocaleUsPriceString(totals[1] / quantities[1], 2) }}/each)
          </span>
        </td>
        <td *ngIf="calculationTableConfig.showThirdCol">
          {{ calculatorService.convertToLocaleUsPriceString(totals[2], 2) }}
          <span class="per-each" *ngIf="quantities[2] > 0">
            ({{ calculatorService.convertToLocaleUsPriceString(totals[2] / quantities[2], 2) }}/each)
          </span>
        </td>
      </tr>
      <ng-container *ngIf="paperWeightData">
        <tr class="paper-group-header">
          <td [attr.colspan]="calculationTableConfig.showThirdCol ? 4 : calculationTableConfig.showSecondCol ? 3 : 2" class="paper-group-name">Paper</td>
        </tr>
        <tr class="paper-row">
          <td class="paper-name">{{ paperWeightData.paperDisplayName }}</td>
          <td>lbs {{ calculatorService.convertToLocaleUsString(math.round(paperWeightData.paperWeight1 ?? 0)) }}</td>
          <td *ngIf="calculationTableConfig.showSecondCol">lbs {{ calculatorService.convertToLocaleUsString(math.round(paperWeightData.paperWeight2 ?? 0)) }}</td>
          <td *ngIf="calculationTableConfig.showThirdCol">lbs {{ calculatorService.convertToLocaleUsString(math.round(paperWeightData.paperWeight3 ?? 0)) }}</td>
        </tr>
      </ng-container>
    </tfoot>
  </table>
</div>
